module.exports = __webpack_public_path__ + "img/jzy_case_02.6961c3c6.jpg";